import { useAtom } from "jotai";

import { dimensionsAtom } from "src/components/DimensionedLayout/dimensionsAtom.ts";

export const useDimensions = () => {
  const [data] = useAtom(dimensionsAtom);
  return data;
};
